module.exports = __webpack_public_path__ + "img/img-137.4cc5fb30.png";